import {animateInViewport} from "../transition";

$( function() {
	$( '.employee-search' ).keyup( function() {
		var $this = $( this );
		employeeSearch( $this );
		animateInViewport();
	} );

	$( '.cat-selector' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();
		var $this = $( this );

		var $employeeSearchField = $( '.employee-search input[type="search"]' );
		$employeeSearchField.val( '' );
		employeeSearch( $employeeSearchField );

		$( '.cat-selector' ).removeClass( 'active' );
		$this.addClass( 'active' );

		var cat = $this.attr( 'href' ).replace( /^#/, '' );

		employees.forEach( function( employee ) {
			if ( $this.hasClass( 'cat-all' ) ) {
				$( '.' + employee.id ).removeClass( 'hidden' ).addClass( 'visible' );
			} else {
				if ( employee.cats.length ) {
					var showEmployee = false;

					employee.cats.forEach( function( currentCat ) {
						if ( cat == currentCat ) {
							showEmployee = true;
						}
					} );

					if ( showEmployee ) {
						$( '.' + employee.id ).removeClass( 'hidden' ).addClass( 'visible' ).addClass( 'active' );
					} else {
						$( '.' + employee.id ).addClass( 'hidden' ).removeClass( 'visible' );
					}
				} else {
					$( '.' + employee.id ).addClass( 'hidden' ).removeClass( 'visible' );
				}
			}
		} );

		$( window ).scrollTop( $( window ).scrollTop() + 1 );
	} );
} );

function employeeSearch( $this ) {
	for ( const group of filteringFlow.schema.groups ) {
		for ( const filterElement of group.data.element.querySelectorAll( '.filtering-filter' ) ) {
			filterElement.classList.remove( 'checked' );
		}
	}
	filteringFlow.filter();

	var searchString = esc_title( $this.val() );

	$( '.employee, .employee .active' ).removeClass( 'active' );

	$( '.no-results' ).addClass( 'hidden' );

	if ( searchString.length ) {
		employees.forEach( function( employee ) {
			if ( employee.slugName.indexOf( searchString ) > -1 || employee.slugTitle.indexOf( searchString ) > -1 || employee.slugDepartment.indexOf( searchString ) > -1 ) {
				$( '#' + employee.id ).removeClass( 'hidden' );
			} else {
				$( '#' + employee.id ).addClass( 'hidden' ).removeClass( 'active' );
			}
		} );
	} else {
		$( '.employee' ).removeClass( 'hidden' );
	}

	if ( searchString.length && $( '.employee' ).not( '.hidden' ).length < 1 ) {
		$( '.no-results' ).removeClass( 'hidden' );
	}
}

function esc_title( string ) {
	string = string.toLowerCase().replace( /[áàâå]/g, 'a' )
		.replace( /[ø]/g, 'o' )
		.replace( /[úùû]/g, 'u' )
		.replace( /[äæ]/g, 'ae' )
		.replace( /[ö]/g, 'oe' )
		.replace( /[ü]/g, 'ue' )
		.replace( /[ß]/g, 'ss' )
		.replace( /[éèë]/g, 'e' )
		.replace( /[í]/g, 'i' );
	return string.replace( /[^0-9a-z]/gi, '' );
}
